import { OrganicEventSearchFiltersApiPayload } from '../../api/searchOrganicEvents';

export function getEventSearchQueryKey(
    eventSearch: OrganicEventSearchFiltersApiPayload,
) {
    // Queries are hashed, so object reference is not important
    return ['search', eventSearch];
}
